import {
    ADD_FAVOURITE_ISSUE_SUCCESS,
    FETCH_ALL_ISSUE_SUCCESS,
    FETCH_ISSUE_SUCCESS,
    FILTER_ISSUE,
    GET_ALL_ISSUE,
    GET_UNSELECTED_ALL_ISSUE,
    HANDLE_ISSUE_REQUEST_CLOSE,
    HIDE_ISSUE_LOADER,
    SHOW_ISSUE_LOADER,
    ON_ADD_ISSUE,
    ON_EDIT_ISSUE,
    ON_ALL_ISSUE_SELECT,
    ON_ISSUE_CLOSE,
    ON_ISSUE_SELECT,
    ON_DELETE_ISSUE_SUCCESS,
    ON_FILTER_SELECTED_ISSUE,
    ON_FILTER_ISSUE_OPTION_SELECT,
    ON_SAVE_ISSUE_SUCCESS,
    ON_TOGGLE_ISSUE_DRAWER,
    SHOW_ISSUE_MESSAGE,
    UPDATE_SEARCH_ISSUE,
    SET_ISSUE,
    CLEAR_SESSION,
    ON_FETCH_SELECT_FEATURE_DATA_SUCCESS,
    CLEAR_SELECTED_OBJECTS
} from 'constants/ActionTypes';
import { addOrUpdateEntry } from 'services/arrayService';

export const ALL_FILTER = 'All issues';
export const STARRED_FILTER = 'Starred issues';
export const SUCCESSFUL_UPDATE = 'Issue Updated Successfully';
export const SUCCESSFUL_FILTER = 'Issue Filtered Successfully';
export const SUCCESSFUL_DELETE = 'Issue Deleted Successfully';
export const REMOVED_AS_STAR = 'Issue removed as star';
export const MARKED_AS_STAR = 'Issue marked as star';

export const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No issues found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: ALL_FILTER,
    allIssue: [],
    issueList: [],
    selectedIssue: null,
    selectedIssues: 0,
    addIssueState: false,
    editIssueState: false,
    searchIssue: '',
    featureSelectionList: [],
    selectedFeatures: 0,
    issue: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case CLEAR_SELECTED_OBJECTS: {
            return {
                ...state,
                selectedIssue: null,
            };
        }
        case ON_FETCH_SELECT_FEATURE_DATA_SUCCESS: {
            return {
                ...state,
                featureSelectionList: action?.payload,
                loader: false,
            };
        }
        case SET_ISSUE: {
            const issues = state.allIssue.filter((entry) => entry?.id === action?.payload);
            return {
                ...state,
                loader: false,
                selectedIssue: issues?.length > 0 ? issues[0] : [],
            };
        }
        case ADD_FAVOURITE_ISSUE_SUCCESS: {
            const allUpdated = state.allIssue.map((entry) => entry?.id === action?.payload?.id ? {
                ...entry,
                starred: !action?.payload?.starred
            } : entry);
            let listUpdated = {};
            switch (state.filterOption) {
                case ALL_FILTER: {
                    listUpdated = allUpdated;
                    break;
                }
                case STARRED_FILTER: {
                    listUpdated = allUpdated.filter((entry) => entry.starred);
                    break;
                }
            }
            return {
                ...state,
                alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
                showMessage: true,
                issueList: listUpdated,
                allIssue: allUpdated,
            };
        }
        case FETCH_ISSUE_SUCCESS: {
            return {
                ...state,
                loader: false,
                selectedIssue: action.payload,
                addIssueState: false,
                editIssueState: false,
            };
        }
        case FETCH_ALL_ISSUE_SUCCESS: {
            return {
                ...state,
                loader: false,
                allIssue: action.payload,
                issueList: action.payload,
                selectedSectionId: 1,
                searchEmp: '',
                filterOption: ALL_FILTER,
                addIssueState: false,
                editIssueState: false,
            };
        }
        case SHOW_ISSUE_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case ON_ISSUE_SELECT: {
            action.payload.selected = !action.payload.selected;
            let selectedFeatures = 0;
            const featureSelectionList = state.featureSelectionList.map(feature => {
                if (feature.selected) {
                    selectedFeatures++;
                }
                if (feature.id === action.payload.id) {
                    if (feature.selected) {
                        selectedFeatures++;
                    }
                    return action.payload;
                } else {
                    return feature;
                }
            }
            );
            return {
                ...state, INIT_STATE,
                selectedFeatures: selectedFeatures,
                featureSelectionList: featureSelectionList
            };
        }
        case ON_ADD_ISSUE: {
            return {
                ...state,
                addIssueState: true,
                editIssueState: false,
            };
        }
        case ON_EDIT_ISSUE: {
            return {
                ...state,
                selectedIssue: action.payload,
                editIssueState: true,
                addIssueState: false,
            };
        }
        case ON_ISSUE_CLOSE: {
            return {
                ...state,
                addIssueState: false,
                editIssueState: false,
            };
        }
        case ON_FILTER_ISSUE_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let issueList = [];
            switch (action.payload.name) {
                case ALL_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    issueList = state.allIssue;
                    break;
                }
                case STARRED_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    issueList = state.allIssue.filter((issue) => issue.starred);
                    break;
                }
            }
            return {
                ...state, selectedSectionId, filterOption, issueList, drawerState: false
            };
        }
        case ON_SAVE_ISSUE_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_UPDATE,
                showMessage: true,
                issueList: addOrUpdateEntry(state.issueList, action.payload),
                allIssue: addOrUpdateEntry(state.allIssue, action.payload),
                selectedIssue: action.payload,
                loader: false,
            };
        }
        // called after a delete from the db operation to keep the current state up to date
        case ON_DELETE_ISSUE_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_DELETE,
                showMessage: true,
                allIssue: state.allIssue.filter((issue) => issue.id !== action.payload),
                issueList: state.allIssue.filter((issue) => issue.id !== action.payload),
                selectedIssue: null,
            };
        }
        case ON_FILTER_SELECTED_ISSUE: {
            const issues = state.allIssue.filter((issue) => !issue.selected);
            return {
                ...state,
                alertMessage: SUCCESSFUL_FILTER,
                showMessage: true,
                issueList: issues,
                selectedIssues: 0
            };
        }
        case FILTER_ISSUE: {
            const { filterOption } = state;
            let issueList = [];
            if (action.payload === '') {
                issueList = state.allIssue;
            } else {
                const filterIssue = state.allIssue.filter((issue) =>
                    issue.name.toLowerCase().indexOf(action.payload.toLowerCase()) > - 1);
                if (filterOption === ALL_FILTER) {
                    issueList = filterIssue;
                } else if (filterOption === STARRED_FILTER) {
                    issueList = filterIssue.filter((issue) => issue.starred);
                }
            }
            return { ...state, issueList: issueList };
        }
        case GET_ALL_ISSUE: {
            let issueList = state.allIssue.map((issue) => issue ? {
                ...issue,
                selected: true
            } : issue);
            return {
                ...state,
                selectedIssues: issueList.length,
                allIssue: issueList,
                issueList: issueList
            };
        }
        case GET_UNSELECTED_ALL_ISSUE: {
            let issueList = state.allIssue.map((issue) => issue ? {
                ...issue,
                selected: false
            } : issue);
            return {
                ...state,
                selectedIssues: 0,
                allIssue: issueList,
                issueList: issueList
            };
        }
        case ON_ALL_ISSUE_SELECT: {
            const selectAll = state.selectedIssues < state.issueList.length;
            let selectedIssues = 0;
            let issueList = [];
            if (selectAll) {
                issueList = state.allIssue.map((issue) => issue ? {
                    ...issue,
                    selected: true
                } : issue);
                selectedIssues = issueList.length;
            } else {
                issueList = state.allIssue.map((issue) => issue ? {
                    ...issue,
                    selected: true
                } : issue);
                selectedIssues = 0;
            }
            return {
                ...state,
                selectedIssues: selectedIssues,
                allIssue: issueList,
                issueList: issueList
            };
        }
        case UPDATE_SEARCH_ISSUE: {
            return { ...state, searchIssue: action.payload };
        }
        case HANDLE_ISSUE_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_ISSUE_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_ISSUE_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_ISSUE_LOADER: {
            return { ...state, loader: false };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/issue.js